import React from "react";
import { Typography, Box } from "@mui/material";
import NSELogo from "../../../ui-utils/latestPics/MultiExg.png";
import BotIcon from "../../../ui-utils/latestPics/CustTrdBot.png";
import PortfolioIcon from "../../../ui-utils/latestPics/Diverse.png";
import StrategyIcon from "../../../ui-utils/latestPics/Isolation_Mode.png";
import Grid from "@mui/material/Grid2";
import MultiExchangeMobileStyle from "./MultiExchangeMobile.module.css";
import en from "../../../i18n/English/Home/exchange.json";
import hi from "../../../i18n/Hindi/Home/exchange.json";
import kn from "../../../i18n/Kannada/Home/exchange.json";
import ma from "../../../i18n/Marathi/Home/exchange.json";
import gu from "../../../i18n/Gujarati/Home/exchange.json";
import { useLanguage } from "../../../Context/LangContext"
export default function MultiExchangeWeb() {
  const { language } = useLanguage();
      const translations = { en, hi, kn  ,gu,ma };
    const t = translations[language] || translations.en ;
  return (
    <Box
      sx={{
        backgroundColor: "#FEF5EE !important",
        minHeight: "100vh",
        width: "100%",
      }}
    >
      <Box
        sx={{
          padding: "52px 15px 78px 15px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Header Section */}
        {/* <Typography
          variant="h4"
          className={MultiExchangeMobileStyle.MultiExchangeMobileheading}
        >
          {t.keyFeatures}
        </Typography> */}

        <div className={MultiExchangeMobileStyle.headingContainer}>
          <div className={MultiExchangeMobileStyle.gradientBackground}></div>
          <Typography className={MultiExchangeMobileStyle.MultiExchangeMobileheading} style={{ fontWeight: 600 }}>
            {t.keyFeatures}
          </Typography>
        </div>

        <Typography
          variant="body1"
          className={MultiExchangeMobileStyle.MultiExchangeMobileSub1}
        >
          {t.experienceSeamless}
        </Typography>

        <Typography
          variant="body1"
          className={MultiExchangeMobileStyle.MultiExchangeMobileSub2}
        >
          {t.description}
        </Typography>

        {/* Key Features Section */}


        <Box sx={{ width: "100%" }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Box
                className={
                  MultiExchangeMobileStyle.MultiExchangeMobileflexColumn
                }
              >
                <Box
                  component="img"
                  src={NSELogo}
                  alt="Multi Exchange Access"
                  sx={{ width: "200px", height: "184px", marginBottom: "6px" }}
                />
                <Typography
                  variant="h6"
                  className={MultiExchangeMobileStyle.MultiExchangeMobileTitles}
                >
                  {t.multiExchangeTitle}
                </Typography>
                <Typography
                  variant="body2"
                  className={
                    MultiExchangeMobileStyle.MultiExchangeMobileContent
                  }
                >
                  {t.multiExchangeDesc}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Box
                className={
                  MultiExchangeMobileStyle.MultiExchangeMobileflexColumn
                }
              >
                <Box
                  component="img"
                  src={BotIcon}
                  alt="Customizable Trading Bots"
                  sx={{ width: "235px", height: "197px", marginBottom: "12px" }}
                />
                <Typography
                  variant="h6"
                  className={MultiExchangeMobileStyle.MultiExchangeMobileTitles}
                >
                  {t.botsTitle}
                </Typography>
                <Typography
                  variant="body2"
                  className={
                    MultiExchangeMobileStyle.MultiExchangeMobileContent
                  }
                >
                  {t.botsDesc}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Box
                className={
                  MultiExchangeMobileStyle.MultiExchangeMobileflexColumn
                }
              >
                <Box
                  component="img"
                  src={PortfolioIcon}
                  alt="Diverse Portfolio Management"
                  sx={{ width: "235px", height: "196px", marginBottom: "8px" }}
                />


                <Typography
                  variant="h6"
                  className={MultiExchangeMobileStyle.MultiExchangeMobileTitles}
                >
                  {t.portfolioTitle}
                </Typography>
                <Typography
                  variant="body2"
                  className={
                    MultiExchangeMobileStyle.MultiExchangeMobileContent
                  }
                >
                  {t.portfolioDesc}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <Box
                className={
                  MultiExchangeMobileStyle.MultiExchangeMobileflexColumn
                }
              >
                <Box
                  component="img"
                  src={StrategyIcon}
                  alt="Optimized Trading Strategies"
                  sx={{ width: "228px", height: "196px", marginBottom: "20px" }}
                />
                <Typography
                  variant="h6"
                  className={MultiExchangeMobileStyle.MultiExchangeMobileTitles}
                >
                  {t.strategiesTitle}
                </Typography>
                <Typography
                  variant="body2"
                  className={
                    MultiExchangeMobileStyle.MultiExchangeMobileContent
                  }
                >
                  {t.strategiesDesc}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
}
